import React, { useContext, useState } from 'react';
import { Button, ButtonStyles, Dropdown, Icons, SwitcherTab } from '@silverfort/sf-components';
import { LAST_CHANGES_OPTIONS } from './Filters';
import IncidentsByStatus from './Statistics/IncidentsByStatus';
import IncidentsBySeverity from './Statistics/IncidentsBySeverity';
import RiskEntitiesOverview from '../RiskEntitiesOverview/RiskEntitiesOverview';
import ItdrContext from '../ItdrContext';
import { Slide } from '@material-ui/core';
import IncidentsGraph from './IncidentsGraph/IncidentsGraph';

const DASHBOARD_TAB_ID = 1;
const GRAPH_TAB_ID = 2;

const OVERVIEW_TABS = [
    { icon: Icons.ComputerInfo, value: DASHBOARD_TAB_ID },
    { icon: Icons.LineChart, value: GRAPH_TAB_ID }
];

const IncidentsOverview = () => {
    const { lastActivityDiffInDays, setLastActivityDiffInDays, setShowConfiguration } = useContext(ItdrContext);
    const [overviewTab, setOverviewTab] = useState(1);

    const onLastChangesFilterChange = (value?: number | number[]) => {
        setLastActivityDiffInDays(value as number);
    };

    return (
        <div className="flex overflow-x-hidden flex-col flex-1 gap-4 w-full h-full">
            <div className="flex flex-none gap-2 justify-end items-center w-full h-8">
                <div className="font-medium font-sf text-12">Time Range</div>
                <Dropdown
                    variant="trigger"
                    items={LAST_CHANGES_OPTIONS}
                    onChange={onLastChangesFilterChange}
                    selectedItems={lastActivityDiffInDays}
                    size="small"
                    className="!max-w-32"
                />
                <div className="w-fit">
                    <SwitcherTab items={OVERVIEW_TABS} onSelect={setOverviewTab} selectedItem={overviewTab} />
                </div>
                <Button
                    text="Customization"
                    buttonStyle={ButtonStyles.Primary}
                    iconLeft={Icons.Settings}
                    onClick={() => setShowConfiguration(true)}
                />
            </div>
            <Slide direction="left" in={overviewTab === DASHBOARD_TAB_ID}>
                <div
                    className={`max-h-50 h-50 w-full flex flex-1 justify-between gap-4 ${
                        overviewTab !== DASHBOARD_TAB_ID ? 'hidden' : undefined
                    }`}>
                    <div className="flex-1"><IncidentsBySeverity /></div>
                    <div className="flex-1"><IncidentsByStatus /></div>
                    <div className="flex-1"><RiskEntitiesOverview /></div>
                </div>
            </Slide>
            <Slide direction="right" in={overviewTab === GRAPH_TAB_ID}>
                <div
                    className={`h-full overflow-y-hidden w-full flex flex-1 justify-between gap-4 ${
                        overviewTab !== GRAPH_TAB_ID ? 'hidden' : undefined
                    }`}>
                    <IncidentsGraph />
                </div>
            </Slide>
        </div>
    );
};

export default IncidentsOverview;
